import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { useLocalization } from '@/contexts/LocalizationContext'

export function NotFoundPage() {
  const { t } = useLocalization()
  return (
    <div className="flex min-h-[100dvh] flex-col items-center justify-center px-4">
      <h1 className="text-3xl sm:text-4xl font-bold mb-3 sm:mb-4">{t('errors.notFoundCode')}</h1>
      <p className="text-sm sm:text-base text-muted-foreground mb-4 sm:mb-6 text-center">{t('errors.notFound')}</p>
      <Button asChild>
        <Link to="/dashboard">{t('errors.goToDashboard')}</Link>
      </Button>
    </div>
  )
}
